import React from "react";
import Alert from "@mui/material/Alert";

import useLessonBooking from "./useLessonBooking";
import useLessonScrollSpy from "./useLessonScrollSpy";
import LessonsMobileLayout from "./LessonsMobileLayout";
import LessonsDesktopLayout from "./LessonsDesktopLayout";

function LessonsView() {
  const lesson = useLessonBooking();
  const scrollSpy = useLessonScrollSpy({
    isMobile: lesson.isMobile,
    bucketedSlots: lesson.bucketedSlots,
    hasSuggested: lesson.suggestedGroups.length > 0
  });

  if (lesson.lessonServices.length === 0 && !lesson.loading) {
    return <Alert severity="info">No private lesson services are currently available.</Alert>;
  }

  return lesson.isMobile ? <LessonsMobileLayout lesson={lesson} scrollSpy={scrollSpy} /> : <LessonsDesktopLayout lesson={lesson} />;
}

export default LessonsView;
